'use client';
import { CurologyLogoStickerIcon } from '@curology/ui-components-web/react/Icon/icons/CurologyLogoStickerIcon';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';

export const ExplanatoryText = ({
  marginTopClass,
  text,
}: {
  marginTopClass?: string;
  text: React.ReactNode;
}) => {
  const { brand } = useFlowContext();

  return (
    <div>
      {brand === 'curology' ? (
        <div
          className={`cur-flex cur-items-center cur-gap-4 ${marginTopClass ?? 'cur-mt-4'}`}
        >
          <CurologyLogoStickerIcon size="xl" />
          <Typography className="cur-flex-1" size="body">
            {text}
          </Typography>
        </div>
      ) : (
        <Typography className="cur-flex-1" size="body">
          Take it to the next level with more{' '}
          <b>dermatologist-designed essentials</b> recommended for your routine.
        </Typography>
      )}
    </div>
  );
};
